exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".book-frame {\n  position: relative;\n}\n\n/* Fills the screen below the header and reader bar */\n.browser-comp {\n  display: block;\n  margin: 0;\n  padding: 0;\n  border: none;\n  width: 100%;\n  height: calc(100vh - 150px);\n  min-height: 560px;\n  background: #ffffff;\n}\n", ""]);

// exports
